import { Component, OnInit } from '@angular/core';
import { GeaMesCognitoAuthService } from '@gea-mes/cognito';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AdminTaskFileDialog } from '../admin-task-file-dialog/admin-task-file-dialog.component';
import { AdminTaskListService } from '../../services/admin-task-list.service';
import { TaskType } from 'src/app/services/tasklist.service';
import { AdminInputDialog } from '../admin-input-dialog/admin-input-dialog.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { MatToolbar } from '@angular/material/toolbar';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-admin-task-list',
    templateUrl: './admin-task-list.component.html',
    styleUrls: ['./admin-task-list.component.scss'],
    imports: [MatButton, MatIcon, FileUploadComponent, MatToolbar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgIf, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class AdminTaskListComponent implements OnInit {
  selectedSite: string;
  site: string;
  environment: string;
  object: string;

  adminFlag: boolean;

  adminSub$: Subscription;
  taskListSub$: Subscription;

  dataSource: any;

  displayedColumns: string[] = [ 'task_type','type', 'tasks', 'time','otherinfo','actions'];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private geaMesCognito: GeaMesCognitoAuthService,
    private svcAdminTaskList:AdminTaskListService
  ) {
    this.selectedSite = this.route.snapshot.paramMap.get('plant');
    this.site = this.route.snapshot.paramMap.get('site');
    this.environment = this.route.snapshot.paramMap.get('environment');
    this.object = this.route.snapshot.paramMap.get('object');

    // Check to see if this user is an admin
    this.adminSub$ = this.geaMesCognito.isUserInRole("Admin").pipe(first()).subscribe( out => { 
      this.adminFlag = out;
      if (this.adminSub$) this.adminSub$.unsubscribe(); // We've got an answer, can unsubscribe now
    });

  }

  ngOnInit(): void {
    this.getTaskList();
  }

  getTaskList(): void {
    if (this.taskListSub$) this.taskListSub$.unsubscribe();
    
    this.taskListSub$ = this.svcAdminTaskList.taskList(this.site, this.object).subscribe((data) => {
      this.dataSource = data.Body;
    });
  }

  navigateObjectList():void {
    this.router.navigate(["/admin",this.selectedSite]);
  }

  openFileList(task:TaskType):void {
    const dialogRef = this.dialog.open(AdminTaskFileDialog, {
      width: '800px',
      data: {task: task,
            site: this.site,
            environment: this.environment,
            object: this.object
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.debug(result)
      this.getTaskList();
    });
  }

  openInput(task:TaskType):void {
    const dialogRef = this.dialog.open(AdminInputDialog, {
      width: '500px',
      maxHeight: '800px',
      data: {task: task
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.debug(result)
      this.getTaskList();
    });
  }


}
